var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"iconfont icon-shuaxin",on:{"click":_vm.handleRefresh}},[_vm._v(" 刷新")])}
var staticRenderFns = []

export { render, staticRenderFns }